import { render } from "./ClaraDetailModal.vue?vue&type=template&id=68bf153d&scoped=true"
import script from "./ClaraDetailModal.vue?vue&type=script&lang=js"
export * from "./ClaraDetailModal.vue?vue&type=script&lang=js"

import "./ClaraDetailModal.vue?vue&type=style&index=0&id=68bf153d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bf153d"]])

export default __exports__